import { memo, forwardRef, FC } from 'react'
import { InputGroup, Input } from '@chakra-ui/react'
import { DynamicFieldProps } from '../..'

type Props = DynamicFieldProps

const InputFilterField: FC<Props> = forwardRef<any, Props>(({ name, onChange, ...props }, ref) => {
  return (
    <InputGroup width="100%" minWidth="min-content">
      <Input name={name} ref={ref} onChange={onChange} {...props} />
    </InputGroup>
  )
})

export default memo(InputFilterField)
